import Avatar from "../components/common/avatar";
import { useUser } from "../redux/user";

export default function UserAvatar({ className }) {
  // avatarUpdateCount used for rerender when there is update
  const { fbId, avatarId, googleId, id, avatarType, avatarUpdateCount } =
    useUser();

  return (
    <Avatar
      fbId={fbId}
      googleId={googleId}
      avatarId={avatarId}
      id={id}
      avatarType={avatarType}
      avatarUpdateCount={avatarUpdateCount}
      className={className}
    />
  );
}
